import { animate, style, trigger, state, transition } from '@angular/animations';

export const panierAnim = trigger("togglePanier", [
    state("show", style({
        transform: "translateY(0)"
    })),
    state("hide", style({
        transform: "translateY(100%)"
    })),
    transition("show => hide", animate("300ms ease-out")),
    transition("hide => show", animate("300ms ease-in"))
]);

export const statusMessageAnim = trigger("toggleStatusMessage", [
    state("show", style({
        bottom: "0"
    })),
    state("hide", style({
        bottom: "-70px"
    })),
    transition("show => hide", animate("300ms ease-out")),
    transition("hide => show", animate("300ms ease-in"))
]);

export const titleBannerAnim = trigger("toggleTitleBanner", [
    state("show", style({
        transform: "translateX(0)"
    })),
    state("hide", style({   
        transform: "{{translateWhere}}"
    }), { params: { translateWhere: 'translateX(-200%)' } }),
    transition("show => hide", animate("200ms ease-out")),
    transition("hide => show", animate("200ms ease-in"))
]);

export const filterDateAnim = trigger("toggleFilterDate", [
    state("show", style({
        transform: "translateY(0)"
    })),
    state("hide", style({
        transform: "translateY(-100%)"
    })),
    transition("show => hide", animate("200ms ease-out")),
    transition("hide => show", animate("200ms ease-in"))
]);